import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  rootOptions: {
    paddingRight: theme.spacing(6),
    paddingLeft: theme.spacing(6),
  },
   titulo: {
    fontSize: '1.3rem !important', 
    color: '#1D1D1D !important',
    fontWeight: '500 !important',
    padding: '0px',
  },
    subTitulo: {
    fontSize: '1.1rem !important', 
    color: '#2813AD !important',
    fontWeight: '500 !important',
    padding: '0px',
  },
    text: {
    fontSize: '1.1rem !important', 
    color: '#696969 !important',
    fontWeight: '500 !important',
    padding: '0px',
  },
}));